/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetDesignTokensQueryResponse,
  GetDesignTokensPathParams,
} from "../types/GetDesignTokens.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getDesignTokensQueryKey = (
  productSheetGroupId:
    | GetDesignTokensPathParams["productSheetGroupId"]
    | undefined
) =>
  [
    {
      url: "/v1/organization-settings/get-design-tokens/:productSheetGroupId",
      params: { productSheetGroupId: productSheetGroupId },
    },
  ] as const

export type GetDesignTokensQueryKey = ReturnType<typeof getDesignTokensQueryKey>

/**
 * @summary Get design tokens by productSheetGroupId
 * {@link /v1/organization-settings/get-design-tokens/:productSheetGroupId}
 */
export async function getDesignTokens(
  productSheetGroupId: GetDesignTokensPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetDesignTokensQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-design-tokens/${productSheetGroupId}`,
    ...requestConfig,
  })
  return res
}

export function getDesignTokensQueryOptions(
  productSheetGroupId:
    | GetDesignTokensPathParams["productSheetGroupId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getDesignTokensQueryKey(productSheetGroupId)
  return queryOptions<
    ResponseConfig<GetDesignTokensQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetDesignTokensQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productSheetGroupId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getDesignTokens(productSheetGroupId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get design tokens by productSheetGroupId
 * {@link /v1/organization-settings/get-design-tokens/:productSheetGroupId}
 */
export function useGetDesignTokens<
  TData = ResponseConfig<GetDesignTokensQueryResponse>,
  TQueryData = ResponseConfig<GetDesignTokensQueryResponse>,
  TQueryKey extends QueryKey = GetDesignTokensQueryKey,
>(
  productSheetGroupId:
    | GetDesignTokensPathParams["productSheetGroupId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetDesignTokensQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getDesignTokensQueryKey(productSheetGroupId)

  const query = useQuery(
    {
      ...getDesignTokensQueryOptions(productSheetGroupId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
